import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import Navbar from "../../ui/Navbar2/Navbar";
import Notifications from "../../ui/Notifications/Notifications";
import { NAVBAR_HEIGHT } from "../../ui/Navbar2/NavbarConstants";

const MainContent = styled.main`
  margin-top: ${NAVBAR_HEIGHT}px;
  flex-grow: 1;
  flex-direction: column;
  display: flex;
  position: relative;
`;

const CommonLayout = ({
  children,
  notifications,
  clearDisplayedNotification,
  navbarMaxWidth,
  ...navbarProps
}) => (
  <>
    <Navbar {...navbarProps} maxWidth={navbarMaxWidth} />

    <MainContent data-testid="common-layout-main-content" role="main">
      {children}
      {notifications && (
        <Notifications
          notifications={notifications}
          clearDisplayedNotification={clearDisplayedNotification}
        />
      )}
    </MainContent>
  </>
);

CommonLayout.defaultProps = {
  alwaysListen: false,
  menus: []
};

CommonLayout.propTypes = {
  /**
   * project root folder (portal, profile2, etc) to distinguish inner and outer links
   */
  projectRoot: PropTypes.string.isRequired,
  /**
   * array of menus to display as part of navbar
   */
  menus: PropTypes.array.isRequired,
  /**
   * if navbar should be constrained to some witdth, set it through this prop. Otherwise 100% of screen will be used
   */
  navbarMaxWidth: PropTypes.number,
  /**
   * determines if menus listen for mouseover events. In "Apple Style Menus"
   * they don't listen until a menu is clicked and stop listening when
   * another menu or the page is clicked
   * {true} means mouse hover over menu to expand it. It hides automatically when mouseout
   * {false} means user needs to click the menu to expand it. It then stays opened until item is clicked or document body is clicked
   */
  alwaysListen: PropTypes.bool,
  /**
   * when you want to set mobile view even though menu links still fit the view
   */
  mobileBreakpoint: PropTypes.number,

  /**
   * slide down notifications
   */
  notifications: PropTypes.arrayOf(
    PropTypes.shape({
      message: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
        .isRequired,
      type: PropTypes.oneOf(["error", "success", "info"])
    })
  ),
  /**
   * when notifications are dismissable, provide a callback function
   */
  clearDisplayedNotification: PropTypes.func.isRequired,
  /**
   * in portal and profile, there's few of menu items, let's make user menu items to be expanded right into top level (in mobile view)
   */
  flatifyMobileMenus: PropTypes.bool
};

export default CommonLayout;
